export const dateWidth = 125
export const billNoWidth = 150
export const amountWidth = 175
export const decimalWidth = 150
export const mobileWidth = 150
export const emailWidth = 200
export const photoWidth = 125
